export default __webpack_public_path__ + "static/media/house.20a89cae.png";